const updateRelationship = (id, relationship) => async (_, __, { api }) => {
  await api.factorCompany.updateFactorCompanyRelationship(id, relationship);
};

export default updateRelationship;
